import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Code, Key, FileCode } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import Layout from '../components/Layout';

// Import des composants existants
import APIKeys from './APIKeys';
import APIDeveloper from './APIDeveloper';

export default function APIHub() {
  const [searchParams, setSearchParams] = useSearchParams();
  const defaultTab = searchParams.get('tab') || 'developer';

  const handleTabChange = (value) => {
    setSearchParams({ tab: value });
  };

  return (
    <Layout>
      <div className="space-y-6" data-testid="api-hub-page">
        {/* Header */}
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-slate-900 flex items-center gap-2">
              <Code className="h-7 w-7 text-indigo-600" />
              API B2RCS
            </h1>
            <p className="text-slate-500 mt-1">
              Intégrez B2RCS dans vos applications via notre API REST
            </p>
          </div>
        </div>

        {/* Tabs */}
        <Tabs value={defaultTab} onValueChange={handleTabChange} className="w-full">
          <TabsList className="grid w-full max-w-md grid-cols-2 mb-6">
            <TabsTrigger value="developer" className="flex items-center gap-2" data-testid="tab-developer">
              <FileCode className="h-4 w-4" />
              Documentation
            </TabsTrigger>
            <TabsTrigger value="keys" className="flex items-center gap-2" data-testid="tab-keys">
              <Key className="h-4 w-4" />
              Clés API
            </TabsTrigger>
          </TabsList>

          <TabsContent value="developer" className="mt-0">
            <APIDeveloper embedded={true} />
          </TabsContent>

          <TabsContent value="keys" className="mt-0">
            <APIKeys embedded={true} />
          </TabsContent>
        </Tabs>
      </div>
    </Layout>
  );
}
